import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {RouterSelectors} from '@store/aviary/aviary.adapter';
import {MyAccountNavComponent} from '@app/layout/my-account-nav/my-account-nav.component';
import {HeaderTopBarComponent} from '@app/layout/header-top-bar/header-top-bar.component';
import {HeaderLogoBarComponent} from '@app/layout/header-logo-bar/header-logo-bar.component';
import {HeaderNavBarComponent} from '@app/layout/header-nav-bar/header-nav-bar.component';
import {FooterComponent} from '@app/layout/footer/footer.component';
import {NgClass} from '@angular/common';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {HttpLoadingSelectors} from '@aviary/store/http-loading/http-loading.selectors';
import {LoadingIndicatorSpinnerComponent} from '@aviary/components/loading-indicator-spinner/loading-indicator-spinner.component';
import {AccountWarningHeaderComponent} from '@app/layout/account-warning-header/account-warning-header.component';

@Component({
  selector: 'px-app-layout',
  host: {
    class: 'flex flex-col min-h-screen'
  },
  templateUrl: './app-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SelectPipe, RouterOutlet, MyAccountNavComponent, HeaderTopBarComponent, HeaderLogoBarComponent, HeaderNavBarComponent, FooterComponent, NgClass,
    LoadingIndicatorSpinnerComponent, AccountWarningHeaderComponent
  ]
})
export class AppLayoutComponent {

  public readonly routerSelectors = RouterSelectors;
  public readonly viewportSelectors = ViewportSelectors;
  public readonly httpLoadingSelectors = HttpLoadingSelectors;
}
